import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/urology")({
  loader: () => loadLegacyContent("urology"),
  head: ({ loaderData }) =>
    loaderData ? legacyHead("/urology", loaderData) : { meta: [{ title: "Urology — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
